import Grid from '@material-ui/core/Grid'
import { useMount } from 'ahooks'
import DatePicker from 'Components/DatePicker'
import Search from 'Components/Search'
import User from 'EurestoClass/User'
import Constants from 'EurestoFonction/Constants'
import React, { useState } from 'react'

export default React.memo(props => <Search limit={30} all raz={true} defaultSearch={props.defaultSearch} group_by={props.group_by}
    path={'alliance_reseaux'} requete={Constants.donnee.reservation} module={Constants.module.ALLIANCE_RESEAUX}
    search={props.search || ((props.searchName || 'alliance_reseaux_') + (props.name || '') + User.Entite.get().id)}>
    <SearchForm />
</Search>
)

const SearchForm = React.memo(props => {
    const [search, setSearch] = useState(props.search || {})
    const searching = (data, name) => {
        const srh = {
            ...(search || {}),
            [name]: data
        }
        setSearch(srh)
        props.searching && props.searching(srh)
    }

    useMount(() => {

    })

    return (
        <Grid container spacing={0} style={{ margin: 0, padding: 5 }} justify={'flex-start'}
            alignItems={'stretch'}
            alignContent={'flex-start'}
            direction={'column'}>
            <DatePicker value={search['|date_creation']}
                range
                title={EurestoI18n.t('commun:Date de création')}
                onChange={searching}
                name={'|date_creation'} />
        </Grid>
    )
})


// WEBPACK FOOTER //
// ./app/App/Module/AllianceReseaux/Component/Search/index.js